import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

// Application Insights connection string from environment variable
// Falls back to empty string for local development without tracking
const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING || '';

const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    autoTrackPageVisitTime: true,
    disableFetchTracking: false,
    disableAjaxTracking: false,
    enableUnhandledPromiseRejectionTracking: true,
  },
});

// Only initialize if connection string is provided
if (connectionString) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

export { reactPlugin, appInsights };
